import { useTranslation } from "react-i18next";
import {
    IconAreaTable
} from "../../../../../components/buttons/IconButtons";
import CustomExpandableCard from "../../../../../components/CustomExpandableCard";
import GeofencesMap from "../../Manage/SubComponents/GeofencesMap";
import GeofencesTabApp from "../Functionality/GeofencesTabApp";
import DetailsGeofencesModal from "../Modal/DetailsGeofencesModal";
import CustomTooltip from "../../../../../components/CustomTooltip";
import CustomChip from "../../../../../components/CustomChip";
import SpeedIndicator from "./SpeedIndicator";
import {statusBorderColor, statusColor, statusFontColor} from "../../../../../enums/statusColorEnum";
import {status} from "../../../../../enums/statusEnum";
import CardListMap from "../../../Company/Payroll/Subcomponents/CardListMap";
import React from "react";
import NotInformation from "../../../../../components/NotInformation";
import ColorPickerPreview from "../../../../../components/ColorPickerPreview";

/**
 * @Author      Jhovanny Fragoso Marquez
 * @JobTitle    Frontend Developer
 * @Email       jfragoso@ibl.mx
 */

const GeofencesTab = (props) => {
    const { direction, handleMapMove, searchElement, setSearchElement, setTotalElements } = props;

    const { t } = useTranslation();
    const {
        getActionsButtons,
        handleToggleModal,
        showModal,
        geofences,
        selected,
        setSelected,
        center
    } = GeofencesTabApp({
        searchElement,
        setSearchElement,
        setTotalElements,
        handleMapMove
    })

    return (
        <>
            {
                geofences?.length === 0 ?
                    <NotInformation card={true} text={t("no_available_geofences")}/>
                    :
                    <div className="w-100 h-100 border-full-shades-100 border-radius-8px position-relative overflow-hidden">
                        { center && geofences &&
                            <GeofencesMap
                                center={center}
                                geofences={geofences}
                                showTitle={false}
                                marginBottom={70}
                                zoom={11}
                                onMapMove={handleMapMove}
                            />
                        }
                        <CustomExpandableCard
                            dividerClassName="background-shades-200 mt-2 mb-2"
                            classNameChildrenContainer={"overflow-y-auto"}
                            header={
                                <div className="row p-0 m-0 gap-3 h-36px">
                                    <CustomTooltip
                                        text={direction}
                                        classes={"pl-0 fs-12px ibl-font-w-500 font-color-primary-700 text-ellipsis-2-rows text-break-wrap"}
                                        showIfTruncated={true}
                                        placement={"top"}
                                    />
                                </div>
                            }
                        >
                            <div className={`${geofences?.length > 0 ? "overflow-y-auto" : " "}`}>
                                {geofences?.map((geofence, index) => (
                                    <CardListMap
                                        key={geofence.id}
                                        icon={<IconAreaTable className="w-100 h-100"/>}
                                        body={
                                            <>
                                                {/* Header */}
                                                <div className="d-flex justify-content-between align-items-center">
                                                    <ColorPickerPreview fillColor={geofence?.fillColor} strokeColor={geofence.strokeColor}/>
                                                    <div className={"flex-grow-1 minw-0"}>
                                                        <CustomTooltip
                                                            text={geofence?.name}
                                                            classes={"font-color-general-950 ibl-font-w-600 fs-16px text-ellipsis-2-rows ml-2"}
                                                            showIfTruncated={true}
                                                            placement={"top"}
                                                        />
                                                    </div>
                                                    {getActionsButtons(geofence, index)}
                                                </div>
                                                {/* Location and speed */}
                                                <div className="d-flex justify-content-flex-start gap-3 pt-1">
                                                    <SpeedIndicator
                                                        speed={geofence?.geofenceConfigDTO?.speedLimit}
                                                        speedUnit={geofence?.geofenceConfigDTO?.speedUnit}
                                                        iconClass="icon-color-shades-500"
                                                        textClass="font-color-shades-500"
                                                    />
                                                    <SpeedIndicator
                                                        speed={geofence?.geofenceConfigDTO?.speedTolerance}
                                                        speedUnit={geofence?.geofenceConfigDTO?.speedUnit}
                                                        iconClass="icon-color-shades-500"
                                                        textClass="font-color-shades-500"
                                                    />
                                                </div>

                                                {/* Status */}
                                                <div className="d-flex justify-content-end">
                                                    <CustomChip
                                                        background={statusColor[geofence?.statusId]}
                                                        fontColor={statusFontColor[geofence?.statusId]}
                                                        borderColor={statusBorderColor[geofence?.statusId]}
                                                        legend={t(status[geofence?.statusId]) || '-'}
                                                        className="border-radius-4px"
                                                    />
                                                </div>
                                            </>
                                        }
                                    />
                                ))}
                            </div>
                        </CustomExpandableCard>

                        { showModal &&
                        <DetailsGeofencesModal
                            show={showModal}
                            onHide={handleToggleModal}
                            item={selected}
                            setItem={setSelected}
                        />
                        }
                    </div>

            }
        </>
    );
};

export default GeofencesTab;
